import { render, staticRenderFns } from "./TermsAndNotices.vue?vue&type=template&id=b6c02b8a&scoped=true&"
import script from "./TermsAndNotices.vue?vue&type=script&lang=js&"
export * from "./TermsAndNotices.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndNotices.vue?vue&type=style&index=0&id=b6c02b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c02b8a",
  null
  
)

export default component.exports